<template>
    <div class="" v-if="appear" @click="flip = !flip">
        <transition name="flip" mode="out-in">
            <figure v-if="flip" class="bg-white shadow-md flex flex-col justify-center w-full h-full" key="front">
                <svg class="outlineAnimation" xmlns="http://www.w3.org/2000/svg"
                     viewBox="0 0 36.5 30.5"><title>development_stroke</title>
                    <g id="74ae5759-aaff-4f29-9819-bf1c213db0dd" data-name="Layer 2">
                        <g id="8fabb2a3-ae52-4629-b1a7-8fa35c790b96" data-name="Layer 1">
                            <rect x="0.25" y="0.25" width="36" height="25" rx="1" ry="1" fill="none" stroke="#395288"
                                  stroke-linecap="round" stroke-linejoin="round" stroke-width="0.5"/>
                            <path d="M.25,22.25h36a0,0,0,0,1,0,0v2a1,1,0,0,1-1,1h-34a1,1,0,0,1-1-1v-2A0,0,0,0,1,.25,22.25Z"
                                  fill="none" stroke="#395288" stroke-linecap="round" stroke-linejoin="round"
                                  stroke-width="0.5"/>
                            <polyline
                                    points="16.36 29.25 12.25 29.25 12.25 30.25 24.25 30.25 24.25 29.25 22.25 29.25 21.25 25.25 15.25 25.25 14.25 29.25"
                                    fill="none" stroke="#395288" stroke-linecap="round" stroke-linejoin="round"
                                    stroke-width="0.5"/>
                            <polyline points="14.14 16.25 9.64 11.75 14.14 7.25" fill="none" stroke="#395288"
                                      stroke-linecap="round" stroke-linejoin="round" stroke-width="0.5"/>
                            <polyline points="22.36 7.25 26.86 11.75 22.36 16.25" fill="none" stroke="#395288"
                                      stroke-linecap="round" stroke-linejoin="round" stroke-width="0.5"/>
                            <line x1="16.3" y1="16.25" x2="20.63" y2="7.25" fill="none" stroke="#395288"
                                  stroke-linecap="round" stroke-linejoin="round" stroke-width="0.5"/>
                        </g>
                    </g>
                </svg>
                <h1 class="font-hairline text-xl text-center mt-6">Webfejlesztés</h1>
            </figure>
            <figure v-else class="shadow-md card flex flex-col justify-center w-full h-full bg-v-blue" key="back">
                <span class="font-light xl:font-hairline font-fira text-white leading-normal p-8">Egyedi megoldások weboldal készítésére meglévő vagy saját fejlesztésű tartalomkezelő rendszerrel. Biztonságosság szem előtt tartása és legújabb technológiák alkalmazása. Teljeskörű ügyintézés domain igényléssel és tárhely kezeléssel.
                </span>
            </figure>

        </transition>
    </div>

</template>

<script>
export default {
  props: ['svg', 'appear'],
  data () {
    return {
      flip: true
    }
  }
}

</script>

<style lang="scss" scoped>
    .outlineAnimation {
        stroke-dasharray: 1000;
        stroke-dashoffset: 0;
        animation: icon-animate-in 2s cubic-bezier(0.95, 0.05, 0.795, 0.035);
    }

    @keyframes icon-animate-in {
        0% {
            stroke-dashoffset: 1000;
        }
        100% {
            stroke-dashoffset: 0;
        }
    }

    figure {
        border-radius: 10px;
    }

    svg {
        height: 5rem;
    }

    .flip-enter-active, .flip-leave-active {
        transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    }

    .flip-enter, .flip-leave-to {
        transform: rotateY(90deg);
        opacity: 0;
    }

</style>



// WEBPACK FOOTER //
// src/components/Webfejlesztes.vue